import { Injectable } from '@angular/core'
import { Maksukortti } from '@lemon/core-firebase/model/maksukortti'
import { Observable, of } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { FirebaseLemonaid } from '../../_angular/service/firebase-lemonaid.service'
import { KayttajaService } from '../../_angular/service/kayttaja.service'

@Injectable()
export class MaksukorttiService {
  constructor(
    private _kayttajaService: KayttajaService,
    private _firebaseLemonaid: FirebaseLemonaid,
  ) {}

  annaMaksukortitObservable(): Observable<Maksukortti[]> {
    return this._kayttajaService.nykyinenAsiakasObservable.pipe(
      switchMap(asiakas => {
        if (!asiakas?.asiakasAvain) {
          return of<Maksukortti[]>([])
        }
        return this._firebaseLemonaid
          .firestoreCollection<Maksukortti>(`customers/${asiakas.asiakasAvain}/maksukortit`)
          .listenSnapshots()
          .pipe(map(snapshots => snapshots.map(snapshot => ({ ...snapshot.data(), avain: snapshot.id }))))
      }),
    )
  }
}
